export const QUICK_START_OS_OPTIONS = ['linux', 'macos', 'windows'] as const

export type QuickStartOs = (typeof QUICK_START_OS_OPTIONS)[number]

export const OS_LINUX = 'linux' satisfies QuickStartOs
export const OS_MACOS = 'macos' satisfies QuickStartOs
export const OS_WINDOWS = 'windows' satisfies QuickStartOs
